import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      console.log("No se encuentra token de login")
      setIsAuthenticated(false);
      setLoadingAuth(false);
      return;
    }
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/user-profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Token válido, mantenemos login...");
      setUserData(response.data);
      setIsAuthenticated(true);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        // Intentar refrescar
        console.log("Token expirado, intentando refrescar...");
        await tryRefreshToken();
      } else {
        console.log("Token expirado, haciendo logout...");
        logout();
      }
    } finally {
      setLoadingAuth(false);
    }
  };

  const tryRefreshToken = async () => {
    const refresh = localStorage.getItem("refresh_token");
    if (!refresh) {
      logout();
      return;
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/token/refresh/`, {
        refresh,
      });
      const newAccess = response.data.access;
      localStorage.setItem("access_token", newAccess);
      await checkAuth();  // Vuelve a comprobar con el nuevo token
    } catch (error) {
      logout();
    }
  };

  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsAuthenticated(false);
    setUserData(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loadingAuth, userData, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
